import {combineReducers} from 'redux';


import authReducer from './authReducer.js';
import campaignReducer from './campaignReducer.js';
import switchHomeSectionReducer from './switchHomeSectionReducer.js';
import logReducer from './logReducer.js';
import coldSmtpReducer from './coldSmtpReducer.js';

//Blacklisting Error property



export default combineReducers({
  auth: authReducer,
  campaign:campaignReducer,
  selectedMenuSection: switchHomeSectionReducer,
  logs:logReducer,
  coldSmtp:coldSmtpReducer
});
